// extracted by mini-css-extract-plugin
export default {"containerPage":"container_containerPage__5QVeD"};